
import { AdminPanelNavigation } from "@/components/AdminPanelNavigation";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DevToolsPanel } from "@/components/DevToolsPanel";

const Analytics = () => {
  const navigate = useNavigate();

  console.log("=== ANALYTICS PAGE LOADED ===");
  console.log("Current URL:", window.location.href);
  console.log("Analytics page rendering");

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-amber-50">
      <div className="container mx-auto py-8">
        <div className="mb-4">
          <Button onClick={handleBack} variant="outline" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
        
        {/* Unified Dev Tools Panel */}
        <DevToolsPanel />
        <AdminPanelNavigation />
      </div>
    </div>
  );
};

export default Analytics;
